import React, { useState } from "react";
import { useParams } from "react-router-dom";
import "./PasswordReset.css";
import api from '../../services/auth';

function ResetPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState(""); // 'success' ou 'error'
  const [loading, setLoading] = useState(false);

  const handleReset = async (e) => {
    e.preventDefault();
    setMessage("");
    setMessageType("");
    if (password !== confirmPassword) {
      setMessage("Les mots de passe ne correspondent pas.");
      setMessageType("error");
      return;
    }
    setLoading(true);
    try {
      const res = await api.post('/password-reset/reset-password', { token, password });
      const data = res.data;
      if (res.status === 200) {
        setMessage("Votre mot de passe a été réinitialisé avec succès. Vous pouvez maintenant vous connecter.");
        setMessageType("success");
      } else {
        let msg = data.detail || data.error || "Impossible de réinitialiser le mot de passe. Merci de réessayer.";
        if (msg.toLowerCase().includes("invalide") || msg.toLowerCase().includes("expiré") || msg.toLowerCase().includes("token")) {
          msg = "Le lien de réinitialisation est invalide ou a expiré. Merci de refaire une demande.";
        } else if (msg.toLowerCase().includes("introuvable") || msg.toLowerCase().includes("not found")) {
          msg = "Utilisateur introuvable. Merci de vérifier le lien ou de refaire une demande.";
        }
        setMessage(msg);
        setMessageType("error");
      }
    } catch (err) {
      setMessage("Erreur réseau ou serveur. Merci de réessayer.");
      setMessageType("error");
    }
    setLoading(false);
  };

  return (
    <div className="reset-container">
      <h2>Réinitialiser le mot de passe</h2>
      <div className="subtitle">Choisissez un nouveau mot de passe sécurisé pour votre compte.</div>
      <form onSubmit={handleReset}>
        <input
          type="password"
          placeholder="Nouveau mot de passe"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Confirmer le mot de passe"
          value={confirmPassword}
          onChange={(e) => setConfirmPassword(e.target.value)}
          required
        />
        <button type="submit" disabled={loading}>
          {loading && <span className="spinner" />} Réinitialiser
        </button>
      </form>
      {message && (
        <div className={`message ${messageType}`}>{messageType === 'error' ? '❌' : '✅'} {message}</div>
      )}
    </div>
  );
}


export default ResetPassword;
